import React, { useState, useEffect } from 'react';
import { getStudentNotices } from '../../api';
import { toast } from 'react-toastify';

const StudentNotices = () => {
  const [notices, setNotices] = useState([]);

  useEffect(() => { loadNotices(); }, []);

  const loadNotices = async () => {
    try {
      const res = await getStudentNotices();
      setNotices(res.data);
    } catch (err) {
      toast.error('Error loading notices');
    }
  };

  return (
    <div>
      <h3 style={styles.title}>📌 Notice Board</h3>

      {notices.length === 0 && (
        <div style={styles.empty}>No notices yet!</div>
      )}

      {notices.map(n => (
        <div key={n.id} style={styles.noticeCard}>
          <div style={styles.noticeHeader}>
            <div style={styles.pinIcon}>📌</div>
            <div style={styles.noticeInfo}>
              <h4 style={styles.noticeTitle}>{n.title}</h4>
              <p style={styles.noticeDate}>
                {new Date(n.created_at).toLocaleDateString()}
              </p>
            </div>
          </div>
          <p style={styles.noticeContent}>{n.content}</p>
        </div>
      ))}
    </div>
  );
};

const styles = {
  title: { color: '#1a3a5c', marginBottom: '20px' },
  empty: { textAlign: 'center', color: '#999', padding: '40px', background: 'white', borderRadius: '12px' },
  noticeCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '15px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)', borderLeft: '4px solid #fd7e14' },
  noticeHeader: { display: 'flex', gap: '12px', alignItems: 'flex-start', marginBottom: '12px' },
  pinIcon: { fontSize: '24px' },
  noticeInfo: { flex: 1 },
  noticeTitle: { color: '#1a3a5c', margin: '0 0 4px', fontSize: '16px' },
  noticeDate: { color: '#999', fontSize: '12px', margin: 0 },
  noticeContent: { color: '#555', fontSize: '14px', lineHeight: '1.6', margin: 0 },
};

export default StudentNotices;